// extracted by mini-css-extract-plugin
module.exports = {"main-component":"close_main-component__8AZL1"};